import enviro from 'enviro';
import { Step } from 'signup-constants/Step';
import { WaveType } from 'signup-components/types';
import { Data } from 'signup-constants/signupData/Data';
import { ErrorKey } from '../app-active-error/ErrorKey';
import { codeVerificationStart } from '../store/step-code-verification/action-creators';
import { CodeVerificationActionTypes } from '../store/step-code-verification/action-types';
import { StepConfigFactory } from './StepConfigFactory';
import { getStepView } from './StepViews';
import { PurchaseActionTypes } from '../store/purchase/action-types';
import { checkDtbIdIsUpToDate } from '../store/purchase/action-creators';
let StepConfigs;
export const getStepConfig = stepKey => {
  if (typeof StepConfigs === 'undefined') {
    StepConfigs = new Map();
    const errorSteps = [Step.EmailVerificationNotFound, Step.InternalError, Step.LoginFailed, Step.StandardCreationError, Step.VerifyFirstCreationError, Step.RateLimitedCreationError, Step.OAuthExistingLoginFailed, Step.OAuthPendingEmailVerification, Step.RateLimitedEmailVerification, Step.EmailVerificationFailed, Step.SessionExpired, Step.ExistingAccountsFetchFailed, Step.RecaptchaCreationError, Step.PartnerExistingAccountError, Step.AlreadyAPartner, Step.WordpressAuthorizationError, Step.IntegratedAppAuthorizationError, Step.BlankScreenLoadingError, Step.PartnerNoRegisteredLeads, Step.NoPartnerPortalsError, Step.EmbeddedSignupContinueScreen, Step.RecaptchaMissingInformationError, Step.MissingBlogIdeasGeneratorScopesError, Step.InvalidDtbIdError];
    errorSteps.forEach(errorStep => StepConfigs.set(errorStep, StepConfigFactory.getStepConfig(errorStep, [], getStepView(errorStep), {
      hideBackButton: true,
      isWideStep: true,
      waveType: WaveType.Error,
      isFramedCentredStep: false
    })));

    // ----------
    // Registration of singular steps
    // ----------

    StepConfigs.set(Step.LandingPage, StepConfigFactory.getStepConfig(Step.LandingPage, [Data.Email], getStepView(Step.LandingPage), {
      hideStepNumber: true,
      hideProgressBar: true,
      shouldShowPrivacyBanner: true
    }));
    StepConfigs.set(Step.Name, StepConfigFactory.getStepConfig(Step.Name, [Data.FirstName, Data.LastName], getStepView(Step.Name)));
    StepConfigs.set(Step.Industry, StepConfigFactory.getStepConfig(Step.Industry, [Data.Industry], getStepView(Step.Industry), {
      stepToButtonColumn: {
        default: 3,
        embedded: 2
      },
      shouldRestrictWidth: false
    }));
    StepConfigs.set(Step.JobRole, StepConfigFactory.getStepConfig(Step.JobRole, [Data.JobRole], getStepView(Step.JobRole), {
      trackSelectedOption: true
    }));
    StepConfigs.set(Step.ManagementLevel, StepConfigFactory.getStepConfig(Step.ManagementLevel, [Data.ManagementLevel], getStepView(Step.ManagementLevel), {
      trackSelectedOption: true,
      stepToButtonColumn: {
        mobile: 1,
        embedded: 2,
        default: 3
      },
      shouldRestrictWidth: false
    }));
    StepConfigs.set(Step.Verification, StepConfigFactory.getStepConfig(Step.Verification, [Data.Verification], getStepView(Step.Verification), {
      hideBackButton: true,
      showMessagingAboveContent: true
    }));
    StepConfigs.set(Step.UnauthedPartnerUserError, StepConfigFactory.getStepConfig(Step.UnauthedPartnerUserError, [], getStepView(Step.UnauthedPartnerUserError), {
      hideBackButton: true,
      hideProgressBar: true,
      isWideStep: true,
      waveType: WaveType.Error,
      isFramedCentredStep: false,
      alignCentredStepAtTheTop: false
    }));
    StepConfigs.set(Step.ResendEmail, StepConfigFactory.getStepConfig(Step.ResendEmail, [Data.Email], getStepView(Step.ResendEmail), {
      showMessagingAboveContent: true
    }));
    StepConfigs.set(Step.Password, StepConfigFactory.getStepConfig(Step.Password, [Data.Password], getStepView(Step.Password), {
      hideBackButton: true
    }));
    StepConfigs.set(Step.MobileAppPrompt, StepConfigFactory.getStepConfig(Step.MobileAppPrompt, [], getStepView(Step.MobileAppPrompt), {
      hideBackButton: true,
      isWideStep: true,
      waveType: WaveType.LowOrange,
      isFramedCentredStep: false
    }));
    StepConfigs.set(Step.ExistingUser, StepConfigFactory.getStepConfig(Step.ExistingUser, [Data.Email, Data.FirstName, Data.LastName], getStepView(Step.ExistingUser), {
      hideProgressBar: true,
      hideBackButton: true,
      isWideStep: true,
      waveType: WaveType.Yellow,
      isFramedCentredStep: false,
      alignCentredStepAtTheTop: false
    }));
    StepConfigs.set(Step.ExistingAccounts, StepConfigFactory.getStepConfig(Step.ExistingAccounts, [], getStepView(Step.ExistingAccounts), {
      hideProgressBar: true,
      isWideStep: true,
      waveType: WaveType.Yellow,
      isFramedCentredStep: false,
      alignCentredStepAtTheTop: false
    }));
    StepConfigs.set(Step.HublessNoAccount, StepConfigFactory.getStepConfig(Step.HublessNoAccount, [], getStepView(Step.HublessNoAccount), {
      hideProgressBar: true,
      isWideStep: true,
      waveType: WaveType.Error,
      isFramedCentredStep: false,
      alignCentredStepAtTheTop: false
    }));
    StepConfigs.set(Step.CompanyDomain, StepConfigFactory.getStepConfig(Step.CompanyDomain, [Data.CompanyDomain], getStepView(Step.CompanyDomain)));
    StepConfigs.set(Step.CompanyName, StepConfigFactory.getStepConfig(Step.CompanyName, [Data.CompanyName], getStepView(Step.CompanyName)));
    StepConfigs.set(Step.IntegrationsAccountCreated, StepConfigFactory.getStepConfig(Step.IntegrationsAccountCreated, [Data.CompanyDomain], getStepView(Step.IntegrationsAccountCreated), {
      hideBackButton: true,
      isFramedCentredStep: false
    }));
    StepConfigs.set(Step.WordpressAuthorization, StepConfigFactory.getStepConfig(Step.WordpressAuthorization, [Data.IntegratedAppRecaptchaToken], getStepView(Step.WordpressAuthorization), {
      hideBackButton: true
    }));
    StepConfigs.set(Step.WordpressConnectRedirect, StepConfigFactory.getStepConfig(Step.WordpressConnectRedirect, [Data.IntegratedAppRecaptchaToken], getStepView(Step.WordpressConnectRedirect), {
      hideBackButton: true
    }));
    StepConfigs.set(Step.IntegratedAppAuthorization, StepConfigFactory.getStepConfig(Step.IntegratedAppAuthorization, [Data.IntegratedAppRecaptchaToken], getStepView(Step.IntegratedAppAuthorization), {
      hideBackButton: true
    }));
    StepConfigs.set(Step.IntegratedAppConnectRedirect, StepConfigFactory.getStepConfig(Step.IntegratedAppConnectRedirect, [Data.IntegratedAppRecaptchaToken], getStepView(Step.IntegratedAppConnectRedirect), {
      hideBackButton: true
    }));
    StepConfigs.set(Step.CodeVerification, Object.assign({}, StepConfigFactory.getStepConfig(Step.CodeVerification, [Data.CodeVerification], getStepView(Step.CodeVerification), {
      showMessagingAboveContent: true,
      hideBackButton: true
    }), {
      beforeComplete: dispatch => dispatch(codeVerificationStart()),
      stepCompletedAction: CodeVerificationActionTypes.Success
    }));
    StepConfigs.set(Step.HubInterest, StepConfigFactory.getStepConfig(Step.HubInterest, [Data.HubInterest], getStepView(Step.HubInterest), {
      trackSelectedOption: true,
      stepToButtonColumn: {
        default: 1
      }
    }));
    StepConfigs.set(Step.AcademyEmbeddedExistingUser, StepConfigFactory.getStepConfig(Step.AcademyEmbeddedExistingUser, [Data.Email, Data.FirstName, Data.LastName], getStepView(Step.AcademyEmbeddedExistingUser), {
      trackSelectedOption: true,
      isWideStep: true
    }));
    StepConfigs.set(Step.HubletSelection, StepConfigFactory.getStepConfig(Step.HubletSelection, [Data.HubletSelection], getStepView(Step.HubletSelection), {
      trackSelectedOption: true,
      stepToButtonColumn: {
        default: 1
      }
    }));
    StepConfigs.set(Step.Country, StepConfigFactory.getStepConfig(Step.Country, [Data.Country], getStepView(Step.Country), {
      trackSelectedOption: true
    }));
    StepConfigs.set(Step.PhoneNumber, StepConfigFactory.getStepConfig(Step.PhoneNumber, [Data.PhoneNumber], getStepView(Step.PhoneNumber)));
    StepConfigs.set(Step.CmsPartnerCompanyDomainAndName, StepConfigFactory.getStepConfig(Step.CmsPartnerCompanyDomainAndName, [Data.CompanyDomain, Data.CompanyName], getStepView(Step.CmsPartnerCompanyDomainAndName)));
    StepConfigs.set(Step.OptionalPhoneNumber, StepConfigFactory.getStepConfig(Step.OptionalPhoneNumber, [Data.OptionalPhoneNumber], getStepView(Step.OptionalPhoneNumber)));
    StepConfigs.set(Step.CmsExistingUser, StepConfigFactory.getStepConfig(Step.CmsExistingUser, [Data.Email, Data.FirstName, Data.LastName], getStepView(Step.CmsExistingUser), {
      hideProgressBar: true,
      hideBackButton: true,
      isWideStep: true,
      waveType: WaveType.Yellow,
      alignCentredStepAtTheTop: false
    }));
    StepConfigs.set(Step.IntegrationsAccountCreated, StepConfigFactory.getStepConfig(Step.IntegrationsAccountCreated, [Data.IntegrationsAccountCreatedCheck], getStepView(Step.IntegrationsAccountCreated), {
      hideBackButton: true,
      isWideStep: true,
      alignCentredStepAtTheTop: false
    }));
    StepConfigs.set(Step.InstallSalesExtension, StepConfigFactory.getStepConfig(Step.InstallSalesExtension, [Data.InstallSalesExtension], getStepView(Step.InstallSalesExtension), {
      isWideStep: true,
      waveType: WaveType.LowOrange,
      isFramedCentredStep: false,
      alignCentredStepAtTheTop: false
    }));
    StepConfigs.set(Step.CompanySize, StepConfigFactory.getStepConfig(Step.CompanySize, [Data.CompanySize], getStepView(Step.CompanySize), {
      trackSelectedOption: true,
      stepToButtonColumn: {
        mobile: 1,
        embedded: 3,
        default: 3
      },
      shouldRestrictWidth: false
    }));
    StepConfigs.set(Step.CrmExperienceLevel, StepConfigFactory.getStepConfig(Step.CrmExperienceLevel, [Data.CrmExperienceLevel], getStepView(Step.CrmExperienceLevel), {
      trackSelectedOption: true,
      isFramedCentredStep: false,
      stepToButtonColumn: {
        default: 1
      }
    }));
    StepConfigs.set(Step.JobField, StepConfigFactory.getStepConfig(Step.JobField, [Data.JobField], getStepView(Step.JobField), {
      trackSelectedOption: true,
      stepToButtonColumn: {
        default: 2,
        mobile: 1,
        embedded: 1
      }
    }));
    StepConfigs.set(Step.CmsSignupIntent, StepConfigFactory.getStepConfig(Step.CmsSignupIntent, [Data.CmsSignupIntent], getStepView(Step.CmsSignupIntent), {
      trackSelectedOption: true,
      stepToButtonColumn: {
        default: 1
      }
    }));
    StepConfigs.set(Step.CmsBusinessMaturity, StepConfigFactory.getStepConfig(Step.CmsBusinessMaturity, [Data.CmsBusinessMaturity], getStepView(Step.CmsBusinessMaturity), {
      trackSelectedOption: true,
      stepToButtonColumn: {
        default: 1
      }
    }));
    StepConfigs.set(Step.ProblemAwareness, StepConfigFactory.getStepConfig(Step.ProblemAwareness, [Data.ProblemAwareness], getStepView(Step.ProblemAwareness), {
      trackSelectedOption: true,
      stepToButtonColumn: {
        default: 1
      }
    }));
    StepConfigs.set(Step.ProductExperience, StepConfigFactory.getStepConfig(Step.ProductExperience, [Data.ProductExperience], getStepView(Step.ProductExperience), {
      trackSelectedOption: true,
      stepToButtonColumn: {
        default: 1
      }
    }));
    StepConfigs.set(Step.UseCase, StepConfigFactory.getStepConfig(Step.UseCase, [Data.UseCase], getStepView(Step.UseCase), {
      trackSelectedOption: true,
      shouldRestrictWidth: false
    }));
    StepConfigs.set(Step.ChooseSeats, Object.assign({}, StepConfigFactory.getStepConfig(Step.ChooseSeats, [], getStepView(Step.ChooseSeats), {
      hideStepNumber: true,
      shouldShowPrivacyBanner: true
    }), {
      beforeComplete: dispatch => dispatch(checkDtbIdIsUpToDate()),
      stepCompletedAction: PurchaseActionTypes.DtbIdIsUpToDate
    }));
    // Local development information
    if (enviro.isQa() && !enviro.deployed()) {
      const allSteps = Object.values(Step);
      const registeredSteps = Array.from(StepConfigs.keys());
      const allDataAndError = [...Object.values(Data), ...Object.values(ErrorKey)];
      const notIncludedInConfig = allDataAndError.filter(x => !registeredSteps.includes(x));
      const notRegistered = allSteps.filter(x => !registeredSteps.includes(x));
      /* eslint-disable no-console */
      console.group('StepConfigs Debug Information');
      console.info(`Data points or error keys not included as a step config`, notIncludedInConfig);
      console.info(`Steps not registered`, notRegistered);
      console.groupEnd();
    }
  }
  return StepConfigs.get(stepKey);
};
export const isValidStepKey = stepKey => {
  return StepConfigs.has(stepKey);
};
export const executeStepBefore = stepKey => dispatch => {
  const stepConfig = getStepConfig(stepKey);
  if (stepConfig && stepConfig.beforeComplete) {
    dispatch(stepConfig.beforeComplete);
  }
};
export const getConfigDataOfStep = stepKey => {
  const stepConfig = getStepConfig(stepKey);
  return stepConfig && stepConfig.data;
};